<script>
  // # # # # # # # # # # # # #
  //
  //  Navigation (mobile)
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { Router, links } from 'svelte-routing'
  import { fly, slide } from 'svelte/transition'

  // COMPONENTS
  import Logo from './Logo.svelte'

  // *** VARIABLES
  let open = false
  let galleryOpen = false
  let architectureOpen = false
  let menuBg = false

  $: {
    setTimeout(() => {
      menuBg = open
    }, 1000)
  }

  $: menuBg = open
</script>

<style lang="scss">
  @import '../_variables.scss';

  .mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    height: 0;
    width: 100vw;
    background: white;
    text-align: center;
    z-index: 1000;
    user-select: none;
    font-size: $mobile-font-size-large;

    display: block;
    pointer-events: none;
    pointer-events: all;

    transition: none;

    &.open {
      padding-top: 90px;
      height: 100vh;
      padding-bottom: 25px;
    }

    &__logo {
      margin-bottom: 30px;
      display: block;
      height: 60px;
      margin-top: 10px;
      cursor: pointer;

      &.top {
        position: fixed;
        z-index: 1001;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
      }

      mix-blend-mode: difference;
    }

    &__item {
      font-family: $serif-stack;
      margin-bottom: $main-margin;

      @include normal-hover-state;
    }

    &__header {
      font-family: $sans-stack;
      margin-bottom: $main-margin;
      cursor: pointer;

      @include normal-hover-state;
    }

    &__section {
      display: block;
      margin-bottom: 30px;
      margin-bottom: $main-margin;
    }
  }

  .disabled {
    color: $grey !important;
    pointer-events: none;
  }
</style>

<Router>

  <div in:fly>

    <!-- {# LOGO #} -->
    <div
      class="mobile-menu__logo top"
      on:click={(e) => {
        open = !open
      }}>
      <Logo />
    </div>

    <!-- {# MOBILE MENU #} -->
    <div class="mobile-menu" class:open={menuBg} use:links>

      {#if open}
        <!-- {# ARCHITECTURE #} -->
        <div
          in:fly|local={{ delay: 0 }}
          class="mobile-menu__header"
          on:click={(e) => {
            architectureOpen = !architectureOpen
          }}>
          Architecture
        </div>

        {#if architectureOpen}
          <div class="mobile-menu__item">
            <a
              in:fly|local={{ delay: 50 }}
              href="/architecture/projects"
              on:click={(e) => {
                open = false
                architectureOpen = false
                galleryOpen = false
              }}>
              Projects
            </a>
          </div>

          <div class="mobile-menu__item">
            <a
              in:fly|local={{ delay: 150 }}
              href="/architecture/brands"
              on:click={(e) => {
                open = false
                architectureOpen = false
                galleryOpen = false
              }}>
              Brands
            </a>
          </div>
        {/if}

        <!-- {# GALLERY #} -->
        <div
          in:fly|local={{ delay: 50 }}
          class="mobile-menu__header"
          on:click={(e) => {
            galleryOpen = !galleryOpen
          }}>
          Gallery
        </div>

        {#if galleryOpen}
          <div class="mobile-menu__item">
            <a
              in:fly|local={{ delay: 50 }}
              href="/gallery/exhibitions"
              on:click={(e) => {
                open = false
                architectureOpen = false
                galleryOpen = false
              }}>
              Exhibitions
            </a>
          </div>

          <div class="mobile-menu__item">
            <a
              in:fly|local={{ delay: 150 }}
              href="/gallery/artists"
              on:click={(e) => {
                open = false
                architectureOpen = false
                galleryOpen = false
              }}>
              Artists
            </a>
          </div>
        {/if}

        <div class="mobile-menu__header">
          <a
            in:fly|local={{ delay: 100 }}
            href="/about"
            on:click={(e) => {
              open = false
              architectureOpen = false
              galleryOpen = false
            }}>
            About
          </a>
        </div>

        <div class="mobile-menu__header">
          <a
            in:fly|local={{ delay: 150 }}
            href="/tags"
            on:click={(e) => {
              open = false
              architectureOpen = false
              galleryOpen = false
            }}>
            Tags
          </a>
        </div>

        <div class="mobile-menu__header">
          <a
            in:fly|local={{ delay: 200 }}
            href="/"
            on:click={(e) => {
              open = false
              architectureOpen = false
              galleryOpen = false
            }}>
            Feed
          </a>
        </div>

        <div class="mobile-menu__header">
          <a
            in:fly|local={{ delay: 250 }}
            href="/contact"
            on:click={(e) => {
              open = false
              architectureOpen = false
              galleryOpen = false
            }}>
            Contact
          </a>
        </div>
      {/if}
    </div>
  </div>
</Router>
